import $ from "jquery";
import React from "react";
import { Button } from "react-materialize";
import { notify } from "react-notify-toast";
import "../../styles/new-style.css";
import Page from "../Page";
import {getBaseUrl} from "../Util"
import TransactionConstants from "../Transaction/Constants";
import { API_PAYMENT, API_VOUCHER,API_SNAP, API_ORDER_ID, BASE_URL, CheckAuth, FormatPrice, scrollToTop } from "../Util";

class Payment extends Page {
	constructor(props) {
		super(props);

		this.state = {
			data: "",
			itemType: "course",
			inputVoucher: "",
			voucherData: "",
			participantData: "",
			order_id: "",
			token_snap: ""
		};
	}

	getOrderId = () => {
		let locationState = this.props.location.state;
		let params = {};
		if(typeof locationState.data != "undefined"){
			 params = {
				"item_uuid" : locationState.data.uuid
			};
		} else {
			if(typeof locationState.is_isw !== 'undefined' && locationState.is_isw){
				params = {
					"item_uuid" : this.props.match.params.uuid,
					"voucher_code" : locationState.voucher_code
				};
			}else{
				params = {
					"item_uuid" : this.props.match.params.uuid
				};
			}
		}
		$.post(API_ORDER_ID , params)
			.then(data => {
				let resp = {
					price: data.payload.grand_total, 
					promotion_price: data.payload.harga_promo, 
					real_price: data.payload.harga_asli, 
					title : data.payload.title, 
					is_isw : data.payload.is_isw,
					cek_trans : data.payload.cek_trans 
				};

				this.setState({ order_id: data.payload.invoice_number, data: {...resp, ...data.payload}  });
				
				this.handleStatus(data.payload)
				if(data.payload.cek_trans == 2 || data.payload.cek_trans == 1){
					this.getToken();
				}else{
					notify.show(data.payload.cek_ket, "warning");
				}
			})
	}

	getToken = () => {
		let order = {"invoice_number" : this.state.order_id};
		let url = {"finish" : BASE_URL +  `/transactions/${order}`}
		$.post(API_SNAP, order, url)
			.then(data => {
				this.setState({ token_snap: data });
			})
	}

	handleStatus = (data) => {
		if(data.status == 0){
			this.props.history.push(`/transactions/${data.invoice_number}`)
		}
	}

	componentDidMount = () => {
		let locationState = this.props.location.state;

		this.getOrderId()

		const script = document.createElement("script");
		var midtransScriptUrl = 'https://app.sandbox.midtrans.com/snap/snap.js'; 
		var myMidtransClientKey = 'SB-Mid-client-X47S1SZMMwCI32HE'; 
		if(window.location.host == "reguler.geti.id"){
			midtransScriptUrl = 'https://app.midtrans.com/snap/snap.js'; 
			myMidtransClientKey = 'Mid-client-naZMRRML0sFJCvAm';
		}

		script.src = midtransScriptUrl;
		script.setAttribute('data-client-key', myMidtransClientKey);
		document.body.appendChild(script);

		if (locationState && CheckAuth()) {
			if (locationState.itemType) {
				// If event, check participant length
				if (locationState.itemType == "event") {
					let participantLength =
						locationState.data.item_data.participants.length;
					locationState.data.title += " x " + participantLength;
					locationState.data.price *= participantLength;
				}
				//a69f87b3-ff48-44dc-9708-7e4e46de1b74

				this.setState(
					{
						data: locationState.data,
						itemType: locationState.itemType,
						participantData: locationState.data.item_data
							? locationState.data.item_data.participants
							: ""
					},
					() => {
						console.log("DATA >>> ", this.state.data);
						console.log("ITEM TYPE >>> ", this.state.itemType);
					}
				);
			} else {
				// notify.show("Item type tidak ditemukan", "warning");
			}
		} else {
			this.props.history.goBack();
		}
		//bcde7a20-21c0-4c28-916c-d924ff89c242
		scrollToTop();
		// this.getOrderId();
		
	};

	handleChangeVoucher = e => {
		let { value } = e.target;
		value = value.toUpperCase();
		this.setState({ inputVoucher: value });
	};

	handleCancelVoucher = e => {
		e.preventDefault();
		let { voucherData } = this.state;
		notify.show("Voucher " + voucherData.code + " dibatalkan", "warning");
		this.setState({ voucherData: "" });
	};

	handleSubmitVoucher = e => {
		e.preventDefault();
		let { inputVoucher, data, itemType } = this.state;
		let params = "?type=" + itemType + "&uuid=" + data.uuid;

		$.get(API_VOUCHER + "/" + inputVoucher + params)
			.then(data => {
				this.setState({ voucherData: data.payload });
			})
			.fail((XMLHttpRequest, textStatus, errorThrown) => {
				var response = null;
				var status = XMLHttpRequest.status;
				try {
					response = JSON.parse(XMLHttpRequest.responseText);
				} catch (e) {}
				if (response && response.status) {
					if (response && response.message) {
						notify.show(response.message, "warning");
						this.setState({ errorMessage: response.message });
					} else if (status == 400 || status == 403) {
						this.setState({ errorMessage: response.message });
					} else {
						this.setState({ errorMessage: response.status });
					}
				}
			});
	};

	handleSnap =  e => {
		//  this.getToken();
		const token = this.state.token_snap.token;
		try {
			window.snap.pay(token, {
				 onSuccess: function(result){
					/* You may add your own implementation here */
				 },
				 onPending: function(result){
					/* You may add your own implementation here */
				 },
				 onError: function(result){
					/* You may add your own implementation here */
					// alert("payment failed!"); console.log(result);
				 },
				 onClose: function(){
					/* You may add your own implementation here */
					// alert('you closed the popup without finishing the payment');
				 }
			});
		 } catch (e) {
			console.log('error',e);
		 }
      
	};

	handleBuy = e => {
		e.preventDefault();
		let { itemType, data, voucherData, participantData } = this.state;
		let itemData = "";
		let voucherCode = voucherData ? voucherData.code : "";

		if (itemType == "event") {
			itemData = JSON.stringify(data.item_data);
		}

		let param = {
			method: TransactionConstants.TRANSFER,
			item_type: itemType,
			item_quantity: participantData.length || 1,
			item_uuid: data.uuid,
			item_data: itemData,
			pin: "000000",
			voucher_code: voucherCode
		};

		// DUMP PARAM
		// console.log("ENROLLMENT PARAM >>> ", param);

		$.post(API_PAYMENT, param)
			.then(data => {
				const { invoice_number } = data.payload;

				this.props.history.push(`/transactions/${invoice_number}`);
			})
			.fail((XMLHttpRequest, textStatus, errorThrown) => {
				var response = null;
				var status = XMLHttpRequest.status;

				try {
					response = JSON.parse(XMLHttpRequest.responseText);
				} catch (e) {}

				if (response && response.status) {
					if (response && response.message) {
						notify.show(response.message, "warning");
						this.setState({ errorMessage: response.message });
					} else if (status == 400 || status == 403) {
						if (this.state.payment_method == TransactionConstants.COUPON) {
							this.setState({ errorMessage: alert.invalid_coupon });
						} else {
							this.setState({ errorMessage: response.message });
						}
					} else {
						this.setState({ errorMessage: response.status });
					}
				}
			});
		};

	render() {
		const { data, inputVoucher, voucherData, itemType, order_id } = this.state;
		const locationState = this.props.location.state

		let finalPrice = data.price;
		let voucherDeduction = 0;
		let voucherMaxAmount = 0;

		if (voucherData) {
			voucherMaxAmount = voucherData.max_amount;
			voucherDeduction = finalPrice * (voucherData.discount / 100);
			voucherDeduction =
				voucherDeduction > voucherMaxAmount
					? voucherMaxAmount
					: voucherDeduction;
			finalPrice = finalPrice - voucherDeduction;
		}
		return (
			<div className="container">
				<div className="payment-page">
					<div className="payment-page-top">
						<a
							className="payment-page-top-icon"
							onClick={() => this.props.history.goBack()}
						>
							<i className="material-icons">keyboard_backspace</i>
						</a>
						<span className="strong">Pembayaran</span>
					</div>
					<form autocomplete="off" onSubmit={e => e.preventDefault()}>
						{data.price !== 0 && (
							<section className="payment-input-voucher">
								{/* <form
									className="payment-input-voucher-inner"
									onSubmit={this.handleSubmitVoucher}
								>
									<input
										placeholder="Kode Voucher"
										value={inputVoucher}
										onChange={this.handleChangeVoucher}
										type="text"
									/>
									{voucherData && (
										<Button
											className="btn btn-pa red"
											onClick={this.handleCancelVoucher}
										>
											Batal
										</Button>
									)}
									{!voucherData && (
										<Button className="btn btn-pa">Gunakan</Button>
									)}
								</form> */}
								{voucherData && (
									<div className="payment-voucher-message font-green">
										{voucherData.title} &nbsp;
										{FormatPrice(voucherDeduction)}
										<br />
									</div>
								)}
								<br />
							</section>
						)}
						<section className="payment-detail">
							<div className="payment-section-title">Detail</div>
							<table>
								<tbody>
									<tr>
										<td>Order id</td>
										<td>{order_id}</td>
									</tr>
									<tr>
										<td style={{width: '100px'}}>{data.title}</td>
										<td className={typeof data.is_isw !== 'undefined' && data.is_isw ? 'isw-price-style' : ''}>{typeof data.real_price !== 'undefined' && data.real_price && data.price_text}</td>
									</tr>
									{
										typeof data.is_isw !== 'undefined' && data.is_isw ? (
											<tr>
												<td>Harga Promo</td>
												<td >{FormatPrice(data.promotion_price)}</td>
											</tr>
										) : data.is_discount && (
											<tr>
												<td>Sub Total Diskon</td>
												<td>-{data.discount_price_text}</td>
											</tr>
										)
									}
									{voucherData && (
										<tr>
											<td>{voucherData.title}</td>
											<td className="red-text">
												- {FormatPrice(voucherDeduction)}
											</td>
										</tr>
									)}
								</tbody>
								<tfoot>
									<tr>
										<td>Total</td>
										<td className="strong">
											<b>
												{data.price > 0 ? data.final_price_text : "GRATIS"}
											</b>
										</td>
									</tr>
								</tfoot>
							</table>
						</section>
						<br />
						<br />
						{
							data.cek_trans != 3 ? 
						<Button
							onClick={this.handleSnap}
							id="enroll-btn"
							className="btn btn-pa full-width-buttons"
						>
							Bayar
						</Button>
						: 
						<Button
							onClick={()=>{
								notify.show("Silahan selesaikan proses pembayaran Anda.", "warning");
							}}
							id="enroll-btn"
							className="btn btn-pa full-width-buttons"
						>
							Bayar
						</Button>
						}
					</form>
				</div>
			</div>
		);
	}
}

export default Payment;



// WEBPACK FOOTER //
// ./src/components/Payment/Payment.js